module.exports = __webpack_public_path__ + "static/media/Ilustracao-inteligencia-operadores.6f739936.svg";